import { Box, type BoxProps, Tooltip } from '@chakra-ui/react'
import { useLayoutEffect, useRef, useState } from 'react'

type Props = BoxProps & {
  label: string
}

/**
 * Single-line text that ellipsizes on overflow and reveals the full value in a hover tooltip,
 * but only when the text is actually truncated. Styling matches the codebase tooltip convention.
 */
export const TruncatedTextWithTooltip = ({ label, ...boxProps }: Props) => {
  const ref = useRef<HTMLDivElement>(null)
  const [isTruncated, setIsTruncated] = useState(false)

  useLayoutEffect(() => {
    const el = ref.current
    if (!el) return
    setIsTruncated(el.scrollWidth > el.clientWidth)
  }, [label])

  return (
    <Tooltip
      label={isTruncated ? label : undefined}
      placement='top'
      hasArrow
      bg='white'
      color='gray.800'
      fontWeight='normal'
      borderRadius='base'
    >
      <Box ref={ref} as='span' minW={0} overflow='hidden' textOverflow='ellipsis' whiteSpace='nowrap' {...boxProps}>
        {label}
      </Box>
    </Tooltip>
  )
}
